import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reload-prompt',
    templateUrl: './reload-prompt.component.html',
    standalone: false
})
export class ReloadPromptComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  hardRefresh(){
    window.location.reload();
  }

}
